import {
  OMSMetricsRequestSchema,
  OMSMetricsResponseSchema,
} from "@redotech/redo-model/fulfillments/metrics";

export const getAvgSurcharge = {
  name: "getAvgSurcharge" as const,
  input: OMSMetricsRequestSchema,
  output: OMSMetricsResponseSchema,
};
